import React from "react";
import { Accordion } from "Components/Base/Surfaces/Accordion";
import ProgramItems from "./Programs/Items";
import { useMyLearning } from "../context";

const AccordionProgram = ({
  isManagerOrAdmin,
  onProgramClick,
  languageContext,
}) => {
  const { listView, filteredPrograms } = useMyLearning();

  if (!filteredPrograms?.active?.length) {
    return null;
  }

  return (
    <Accordion
      defaultExpanded
      slotProps={{ transition: { unmountOnExit: true, timeout: 0 } }}
      disableGutters
      TransitionProps={{ timeout: 0 }}
      summaryText={languageContext("programs")}
      summaryVariant="h2"
      detailsText={
        <div
          className={`${listView ? "learning-courselist" : "cardview-courselist"} flex flex-wrap`}
          id="programMyLearningList"
        >
          <ProgramItems
            context={languageContext}
            onClick={onProgramClick}
            managerView={isManagerOrAdmin}
          />
        </div>
      }
    />
  );
};

export default AccordionProgram;
